// Your own order of the productions (sidebar and Productions), kept on the server per person. Pure.

/** `items` in the order of `ids`; items not in it follow in their own order. */
export function applyOrder<T extends { id: string }>(items: readonly T[], ids: readonly string[]): T[] {
  const at = new Map(ids.map((id, i) => [id, i]));
  const known = items.filter((p) => at.has(p.id)).sort((a, b) => at.get(a.id)! - at.get(b.id)!);
  return [...known, ...items.filter((p) => !at.has(p.id))];
}

/** The ids with `id` moved to index `to` (clamped); the same list when it does not move. */
export function moveId(ids: readonly string[], id: string, to: number): string[] {
  const from = ids.indexOf(id);
  if (from < 0) return [...ids];
  const rest = ids.filter((x) => x !== id);
  const at = Math.max(0, Math.min(rest.length, to));
  return [...rest.slice(0, at), id, ...rest.slice(at)];
}

/**
 * Where a dragged row lands: `slot` is the gap it hovers (0 = before the first row, n = after the last); the
 * index it gets once it has left its own place. Null when it would stay where it is.
 */
export function dropIndex(from: number, slot: number): number | null {
  if (slot === from || slot === from + 1) return null;
  return slot > from ? slot - 1 : slot;
}
